var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"rel":"nofollow","href":"https://www.ccbillcomplaintform.com/ccbill/form/CCBillContentRemovalRequest1/formperma/sBK2jfIoZWAFw2hRRt5Rv2PQncscFzpvOH6bPcwopas"}},[_vm._v(_vm._s(_vm.$t('components.cc_bill.complaints')))])}
var staticRenderFns = []

export { render, staticRenderFns }